import { useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SiteDetailsInfo, SiteUserList, SiteTasks, SiteFiles } from "./Components";
import { useSites } from "./Hooks/useSites";
import { SiteContext } from "../../Context";

const SiteDetails = () => {
  const { instanceId } = useParams();
  const navigate = useNavigate();
  const { fetchSiteById, loading } = useSites({ siteId: instanceId });
  const { site } = useContext(SiteContext);

  useEffect(() => {
    fetchSiteById({ site: "all" });
  }, [instanceId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[150px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="p-2 h-full">
      <div className="space-y-2">
        <div>
          <div className="flex gap-2 py-3 items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="text-primary text-center text-sm font-lg"
            >
              <ArrowLeft
                size={25}
                absoluteStrokeWidth
                className="text-primary"
              />
            </button>
            <h1 className="text-2xl font-bold">
              Site Details
            </h1>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-10 gap-3 px-2 h-full pb-4">
          <div className="flex flex-col gap-3 md:col-span-7 h-full">
            <div className="bg-white border border-gray-200 shadow-md p-3 flex-shrink-0">
              {site && <SiteDetailsInfo siteId={instanceId} />}
            </div>

            <div className="bg-white border border-gray-200 shadow-md p-3 pb-2 flex-1 overflow-hidden h-full">
              <div className="h-full min-h-[35vh] max-h-[40h] overflow-y-auto">
                {site.id && <SiteTasks />}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 md:col-span-3 h-full">
            <div className="bg-white border border-gray-200 shadow-md p-3 flex-1 overflow-hidden">
              <div className="h-full min-h-[25vh] max-h-[50vh] overflow-y-auto">
                <SiteUserList siteId={instanceId} />
              </div>
            </div>

            <div className="bg-white border border-gray-200 shadow-md p-3 pb-0 flex-1 overflow-hidden">
              <div className="h-full min-h-[25vh] max-h-[55vh] overflow-y-auto">
                <SiteFiles siteId={instanceId} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteDetails;

